import React, { Component } from "react";
import { connect } from "react-redux";
import CellVoltChartWrap from "./wrapper/cell-volt-chart-wrapper";
const mapStateToProps = (state = {}) => {
  return { ...state };
};

// Assuming cellEMSData is the state containing EMS data
class CellVoltChart extends Component {

  constructor(props) {
    super(props);

  }


  render() {
    
    var {cellEMSData }= this.props
    var cellVoltArr=[]
    var cellNoArr = []
    var cellNo=1;
    
    console.log("cellEMSData",cellEMSData)

    if(Object.keys(cellEMSData).length > 0){
      cellEMSData['slaves'].forEach(cellArr => {
        cellArr['cells'].forEach(cell=>{
          cellVoltArr.push(cell['v']/1000)
          cellNoArr.push(cellNo)
          cellNo++
        });
      });
      console.log("Each EMS Data through Cell Volt",cellVoltArr,cellNoArr)
    
        
      return (
        <CellVoltChartWrap 
        cellVoltArr ={cellVoltArr}
        cellNoArr={cellNoArr}
        style={{ padding: "10px", margin: "10px" }}
        />
      );
    } else {
      return (<div style={{ padding: "10px", margin: "10px" }}>No Real Time Cell Volt Data Available</div>)
    }
  }
}
export default connect(mapStateToProps)(CellVoltChart);
